export default __webpack_public_path__ + "static/media/kamivest_logo_center.8fd76447.svg";